export const getTokenData = (token?: string | null) => {
  if (!token) {
    return;
  }

  try {
    const secondSegmentEncoded = token.split('.')[1];
    return JSON.parse(atob(secondSegmentEncoded));
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('Error decoding token'); // we don't have a token, so we can't send a log
  }
};
